import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { AddCircleOutlined, DownloadOutlined, EditOutlined, PauseCircleOutlined } from "@mui-symbols-material/w300"

interface CompanyHeaderDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  isActive: boolean
  onEdit: () => void
  onDeactivate: () => void
  onActivate: () => void
  setIsDownloadPriceDialogOpen: (open: boolean) => void
  disabled?: boolean
  canDownloadPriceList: boolean
}

const CompanyHeaderDropdownMenu: React.FC<CompanyHeaderDropdownMenuProps> = ({
  anchorEl,
  onClose,
  isActive,
  onEdit,
  onDeactivate,
  onActivate,
  setIsDownloadPriceDialogOpen,
  canDownloadPriceList,
  disabled = false,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={onEdit} disabled={disabled}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary='Edit' className='text-gray-800' />
      </MenuItem>
      {canDownloadPriceList && (
        <MenuItem disabled={disabled} onClick={() => setIsDownloadPriceDialogOpen(true)}>
          <ListItemIcon>
            <DownloadOutlined />
          </ListItemIcon>
          <ListItemText className='text-gray-800' primary='Download Price List' />
        </MenuItem>
      )}
      {isActive ? (
        <MenuItem onClick={onDeactivate} disabled={disabled}>
          <ListItemIcon>
            <PauseCircleOutlined />
          </ListItemIcon>
          <ListItemText primary='Deactivate' className='text-gray-800' />
        </MenuItem>
      ) : (
        <MenuItem onClick={onActivate} disabled={disabled}>
          <ListItemIcon>
            <AddCircleOutlined />
          </ListItemIcon>
          <ListItemText primary='Activate' className='text-gray-800' />
        </MenuItem>
      )}
    </Menu>
  )
}

export default CompanyHeaderDropdownMenu
